import { render, staticRenderFns } from "./Chat.html?vue&type=template&id=707d1f5b&scoped=true&"
import script from "./Chat.js?vue&type=script&lang=js&"
export * from "./Chat.js?vue&type=script&lang=js&"
import style0 from "./Chat.scss?vue&type=style&index=0&id=707d1f5b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707d1f5b",
  null
  
)

export default component.exports